import React from "react";
import { Link, useNavigate } from 'react-router-dom';
import "../../assets/css/bootstrap.min.css";
import "../../assets/css/fontawesome-all.min.css";
import "../../assets/css/slick.css";
import "../../assets/css/line-awesome.min.css";
import "../../assets/css/main.css";
import "../../assets/css/responsive.css";

// Import images

import FeedImage from "../../assets/images/all/fedd.png";
import { Footer } from "../../components";
import StudentSidebar from "../../components/StudentSidebar";
import GlobalSearch from "../../components/GlobalSearch";
import CommanStudentTeacherHeader from "../../components/CommanStudentTeacherHeader";


const StudentCertificate = () => {
  const navigate = useNavigate();
  return (
    <div className="bg_dashboard">
      {/* Mobile Menu */}
        <CommanStudentTeacherHeader/>

      {/* Main Content */}
      <div className="container">
        <div className="row">
          {/* Sidebar */}
         <StudentSidebar/>

          {/* Main Content Area */}
          <div className="col-sm-9 col-md-12 col-xl-9 px-md-5 ps-xl-5">
           <GlobalSearch/>

            <div className="row align-items-center">
              <div className="col-sm-12">
                <p className="learm-tilte my-3">Certificates</p>
              </div>
            </div>

            <div className="row gy-3 p-0 mb-5">
              {/* Card start */}
              {[...Array(5)].map((_, index) => (
                <div key={index} className="col-sm-4" onClick={()=>navigate('/StudentCertificateDetail')}>
                  <div className="dashboard_card p-3">
                    <div className="feed_imgs" style={{ height: "140px" }}>
                      <img className="rounded-3" src={FeedImage} alt="Certificate" />
                    </div>
                    <span className="course_video_time mt-2">Atomic & Nuclear Particle Physics</span>
                    <span className="dashboard_subitel">Instructor: Alok Jain</span>
                  </div>
                </div>
              ))}
              {/* Card end */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default StudentCertificate;
